export {
    default as Emoticons,
} from './emoticons';
